export default __webpack_public_path__ + "static/media/co_foreign_back.9fd2a93e.jpeg";